// libs
import { styled } from '@nykaa/ui-components';

// components
import ModalBase from 'shared/components/Modal';
import DropdownBase from 'shared/components/Dropdown';

export const Dropdown = styled(DropdownBase)`
  margin-bottom: 18px;
`;

export const Content = styled.div`
  @media (max-width: 768px) {
    overflow-y: auto;
    height: calc(100% - 70px);
    position: fixed;
    padding: 25px;
    bottom: 0;
    left: 0;
  }

  &:after {
    content: '';
    clear: both;
    display: table;
  }
`;

export const modalInnerClassName = 'modal_content_wrapper';
export const Modal = styled(ModalBase)`
  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    overflow: hidden;
  }

  .${modalInnerClassName} {
    width: 720px;
    padding: 25px 40px;
    ${({ theme }) => theme.typography.bodyMedium};
    color: #000;

    @media (max-width: 768px) {
      width: 100%;
      ${({ theme }) => theme.typography.bodySmall};
      padding: 25px;
    }
  }
`;

export const LogoCnt = styled.span`
  width: 74px;
  height: 35px;
  display: inline-block;
  margin-bottom: 18px;
  @media (max-width: 768px) {
    width: 59px;
    height: 28px;
    display: block;
    margin: 0 auto 20px;
  }
`;

export const Heading = styled.h4`
  margin: 0 0 20px 0;
  font-weight: 500;
  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const ListHeading = styled.h4`
  margin: 0;
  font-weight: bold;
  @media (max-width: 768px) {
    margin-top: 18px;
  }
`;

export const Countries = styled.p`
  margin: 10px 0 20px 0;
  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const ShippingInfo = styled.ul`
  padding-left: 25px;
  margin: 25px 0 0 0;
  list-style: none;

  & li {
    position: relative;
    margin-bottom: 5px;
    &:before {
      content: '';
      width: 3px;
      height: 3px;
      position: absolute;
      border-radius: 50%;
      left: -25px;
      top: 8px;
      background: #000;
    }
  }
`;

export const Label = styled.label`
  font-weight: 500;
  display: block;
  margin-bottom: 8px;
  color: #393939;
`;

export const InnerContent = styled.section`
  float: left;
  width: 320px;

  &:first-of-type {
    padding-right: 40px;
    border-right: 1px solid #ccc;
  }

  &:last-of-type {
    padding-left: 35px;
  }

  @media (max-width: 768px) {
    float: none;
    width: 100%;

    &:first-of-type {
      padding-right: 0;
      border-right: none;
    }

    &:last-of-type {
      padding-left: 0;
    }
  }
`;

export const Para = styled.p`
  margin: 0;
`;

export const Button = styled.button`
  width: 100%;
  background: #000;
  color: #fff;
  font-weight: bold;
  text-transform: uppercase;
  height: 45px;
  border-radius: 2px;
  border: 0;
  outline: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 10px 0;
`;

export const MoreLink = styled.a`
  text-decoration: underline;
  cursor: pointer;
`;
